<template>
  <div class="app-voucher-input">
    <slot name="txtBefore"></slot>
    <b-form>
      <b-form-group>
        <b-form-row>
          <b-col class="label-col" sm="12" md="">
            <label><slot name="lblInput">Geben Sie hier die Aufladennummer ein</slot></label>
          </b-col>
          <b-col class="input-col">
            <b-form-input
              name="voucher"
              type="text"
              required
              v-model="voucherStr"
              @input="$v.voucherStr.$touch"
              :state="isValid('voucherStr')"
              :placeholder="placeholder"
            ></b-form-input>
          </b-col>
        </b-form-row>
      </b-form-group>
    </b-form>
    <slot name="txtAfterInput"></slot>
    <Stepper
      :show-prev="false"
      @next="next()"
      :disabled-next="$v.$invalid || loading"
      :loading-next="loading"
    >
      <template v-for="slot in possibleChildSlotsFor('Stepper')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </Stepper>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import { validationMixin } from 'vuelidate'
import isValid from '@/mixins/isValid'
import { mapActions } from 'vuex'
import transaction from '@/mixins/transaction'
import Stepper from '@/components/generic/Stepper.vue'
import slotProxy from '@/mixins/slotProxy'

export const stepName = 'input'

export default {
  name: 'VoucherInput',
  components: { Stepper },
  props: {
    placeholder: {
      type: String,
      default: 'Aufladecode'
    },
    nextStep: {
      type: String,
      default: 'topUpVoucherSuccess'
    }
  },
  mixins: [
    transaction('voucher'),
    validationMixin,
    isValid,
    slotProxy()
  ],
  data: function () {
    return {
      loading: false,
      voucherStr: ''
    }
  },
  methods: {
    ...mapActions('topUp', [
      'sendVoucher'
    ]),
    async next () {
      await this.save()
    },
    reset () {
      this.voucherStr = ''
      this.$v.voucherStr.$reset()
    },
    async save () {
      this.loading = true
      await this.sendVoucher({
        voucher: this.voucherStr,
        nextStep: this.nextStep
      })
      this.reset()
      this.loading = false
    }
  },
  validations () {
    return {
      voucherStr: {
        required,
        validateVoucher: (this.$config?.validation?.validateVoucher) || ((voucher) => true)
      }
    }
  }
}
</script>
